import { RouteEntry } from "../../shared/routes";
import { SubscriptionTemplateLinksList } from './SubscriptionTemplateLinksList';
import { IdentityRoles } from "../../configure/security/IdentityRoles";

export const subscriptionTemplateLinksRoutes: Array<RouteEntry> = [
    { path: '/manage/subscriptions/edit/templateLinks', exact: true, component: SubscriptionTemplateLinksList, authorize: true, requireRole: IdentityRoles.SubscriptionAdministration },

    { path: '/administration/subscriptions/edit/templateLinks/:id', exact: true, component: SubscriptionTemplateLinksList, authorize: true, requireRole: IdentityRoles.Administration },
];
